import { LabExample } from "./lab";
import {
	hydrateLabHttpStateFromSessionStorage,
	persistLabHttpToSessionStorage,
} from "../utils/lab_persist";

export interface LabHttpState {
	requestTab: string;
	responseTab: string;
}

const INITIAL_STATE: LabHttpState = {
	requestTab: "",
	responseTab: "body",
};

function modifyInitialState(state: LabHttpState): LabHttpState {
	// do nothing on server-side render
	if (typeof window !== "object") {
		return state;
	}

	try {
		const hydratedState: LabHttpState = hydrateLabHttpStateFromSessionStorage(state);

		return {
			...state,
			...hydratedState,
		};
	} catch (e) {
		return state;
	}
}

export default (
	state: LabHttpState = modifyInitialState(INITIAL_STATE),
	action: any
): LabHttpState => {
	switch (action.type) {
		case "LAB/OPEN": {
			const example: LabExample = action.data.example;

			if (example.type !== "http") {
				return state;
			}

			return {
				...state,
				requestTab: getBestRequestTab(example.data.request.method, example.data.request.body),
			};
		}

		case "LAB/CLOSE": {
			return {
				...state,
			};
		}

		case "LAB/HISTORY/LOAD_REQUEST": {
			const example: LabExample = action.data.example;

			if (example.type !== "http") {
				return state;
			}

			return {
				...state,
				requestTab: getBestRequestTab(example.data.request.method, example.data.request.body),
			};
		}

		case "LAB/CHANGE_REQUEST_TAB": {
			return {
				...state,
				requestTab: action.data.tab,
			};
		}

		case "LAB/CHANGE_RESPONSE_TAB": {
			return {
				...state,
				responseTab: action.data.tab,
			};
		}
	}

	return state;
};

export const actions = {
	changeRequestTab: (tab: string) => async (dispatch, getState) => {
		await dispatch({
			type: "LAB/CHANGE_REQUEST_TAB",
			data: { tab },
		});

		const state: LabHttpState = labHttpState(getState());
		persistLabHttpToSessionStorage(state);
	},
	changeResponseTab: (tab: string) => async (dispatch, getState) => {
		await dispatch({
			type: "LAB/CHANGE_RESPONSE_TAB",
			data: { tab },
		});

		const state: LabHttpState = labHttpState(getState());
		persistLabHttpToSessionStorage(state);
	},
};

export const labHttpState = state => state.labHttp as LabHttpState;

export const selectors = {
	selectRequestTab: state => labHttpState(state).requestTab,
	selectResponseTab: state => labHttpState(state).responseTab,
};

/**
 * returns true if the http method allows a body
 * @param httpMethod
 * @param defaultRequestBody the request body as specified in the example
 */
export const methodAllowsBody = (
	httpMethod: string,
	defaultRequestBody: string = null
): boolean => {
	return !!defaultRequestBody;
};

/**
 * returns the best tab id to use given the availability of those tabs
 * @param nextHttpMethod the http method of the request that will be switched to
 * @param defaultRequestBody the request body as specified in the new example
 */
export const getBestRequestTab = (
	nextHttpMethod: string,
	defaultRequestBody: string = null
): string => {
	if (!methodAllowsBody(nextHttpMethod, defaultRequestBody)) {
		return "headers";
	}

	return "body";
};
